import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import { LAYER_ATTRIBUTIONS } from '@/constants/layers/attributions'
import type { LayerInfo } from '@/types/LayerInfo'

const info: LayerInfo = {
  description: {
    'en-US': 'Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4',
    'es-ES': 'Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4',
    'pt-BR': 'Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4',
    'fr-FR': 'Shuttle Radar Topography Mission (SRTM) Digital Elevation Data Version 4'
  },
  credit: LAYER_ATTRIBUTIONS.nasa,
  sourceUrl: 'https://developers.google.com/earth-engine/datasets/catalog/CGIAR_SRTM90_V4'
}

const elevationNorthAfrica: LayerRaw = {
  id: 'elevation_layer',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  extraArcgisParameter: { copyright: info.credit },
  title: {
    'en-US': 'Elevation',
    'pt-BR': 'Elevação',
    'es-ES': 'Elevación',
    'fr-FR': 'Élévation'
  },
  zindex: 1,
  opacity: 0.5,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  legend: {
    title: 'n/a'
  },
  customProperties: { group: 'reference', info },
  sublayers: [
    {
      id: 'naf:NWAF_DEM',
      visible: true,
      legend: {
        title: {
          'en-US': 'Elevation',
          'pt-BR': 'Elevação',
          'es-ES': 'Elevación',
          'fr-FR': 'Élévation'
        },
        items: [
          {
            color: '#ff0000',
            icon: 'mdi-close',
            text: {
              'en-US': 'No Data',
              'pt-BR': 'Sem dados',
              'es-ES': 'Sin Datos',
              'fr-FR': 'Aucune donnée'
            }
          },
          {
            type: 'ramp',
            items: [
              {
                color: '#D53E4F',
                ratio: 0
              },
              {
                color: '#EC6D54',
                ratio: 0.14
              },
              {
                color: '#FEE08B',
                ratio: 0.29
              },
              {
                color: '#FFFFBF',
                ratio: 0.43
              },
              {
                color: '#F1F9AA',
                ratio: 0.57
              },
              {
                color: '#B7E195',
                ratio: 0.71
              },
              {
                color: '#99D594',
                ratio: 0.86
              },
              {
                color: '#3288BD',
                ratio: 1
              }
            ]
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
}

export default elevationNorthAfrica
